import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Grid, TextField } from '@mui/material';
import PageFilter from '../../../component/PageFilter';
import AutoCompleteComponent from '../../../component/Autocomplete';
import ModalDropDown from '../../Events/ModalDropDown';
import { changeByOptions } from '../../../constants';
import FormNumberField from '../../../component/NumberInput';

const EditMappingEventModal = ({
    options,
    modalEditField,
    open,
    onClose,
    searchForm,
    sheetFilter,
    handleSheetFilter,
    handleSearchValueAutoComplete,
    autoCompleteOptions,
    autoCompleteLoading,
    handleBlurUpdate,
    handleChangeAutoComplete,
    inputRef,
    handleSubmitRowLocalStorage,
    handleChangeBy,
    showChangeBy,
    searchValue
}) => {

    return (
        <Dialog closeAfterTransition={false} fullWidth maxWidth={'md'} open={open} onClose={onClose}>
            <DialogTitle>Edit Event Field </DialogTitle>
            <DialogContent>
                {(modalEditField?.fieldName === 'SigAddr' || modalEditField?.fieldName === 'IB1' || modalEditField?.fieldName === 'IB2' || modalEditField?.fieldName?.slice(0,-1) === 'Sig') && 
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin='dense'
                                disabled={true}
                                value={modalEditField.value} 
                                label={modalEditField?.label}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <PageFilter
                                options={options}
                                //width={96}
                                filterValue={sheetFilter}
                                handleSheetFilter={handleSheetFilter} 
                            />
                        </Grid> 
                        {searchForm &&
                            <Grid  item xs={12} sm={4} md={4}>
                                <AutoCompleteComponent 
                                    name={modalEditField?.fieldName}
                                    label="Search Text"
                                    options={autoCompleteOptions}
                                    loading={autoCompleteLoading}
                                    handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                                    handleChangeAutoComplete={handleChangeAutoComplete}
                                    inputRef={inputRef}
                                    index={""}
                                    value={searchValue}
                                />
                            </Grid>
                        }
                    </Grid>
                }
                {(modalEditField?.fieldName === 'Div' ||  modalEditField?.fieldName === 'ECNTRSig' ||  modalEditField?.fieldName === 'TOn' || modalEditField?.fieldName === 'LOS' ||  modalEditField?.fieldName === 'TOff' || modalEditField?.fieldName === 'ECNTRDel' ||  modalEditField?.fieldName === 'ARTFactor' || modalEditField?.fieldName === 'IBT1' ||  modalEditField?.fieldName === 'IBT2' || modalEditField?.fieldName === 'En' )  &&
                    <Grid container direction="row" spacing={2}>
                        <Grid  item xs={12} sm={4} md={3} >
                            <TextField
                                fullWidth
                                margin='dense'
                                disabled={true}
                                value={modalEditField.value} 
                                label={modalEditField?.label}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <ModalDropDown 
                                //width={100}
                                label="Select Change By" 
                                value={showChangeBy}
                                name={"changeby"}
                                options={changeByOptions}
                                handleDropDownChange={handleChangeBy}
                            />
                        </Grid>
                        {showChangeBy === '1' &&
                            <Grid item xs={12} sm={4} md={3}>
                                <PageFilter
                                    options={options}
                                   // width={96}
                                    filterValue={sheetFilter}
                                    handleSheetFilter={handleSheetFilter} 
                                />
                            </Grid> 
                        }
                        {showChangeBy === '2' &&
                            <Grid item xs={12} sm={4} md={3}>
                                {(modalEditField?.fieldName === 'Div' ||  modalEditField?.fieldName === 'TOn' || modalEditField?.fieldName === 'LOS' ||  modalEditField?.fieldName === 'TOff' || modalEditField?.fieldName === 'ECNTRDel' ||  modalEditField?.fieldName === 'ARTFactor' || modalEditField?.fieldName === 'IBT1' ||  modalEditField?.fieldName === 'IBT2' || modalEditField?.fieldName === 'En' || modalEditField?.fieldName === 'ECNTRSig' ) &&
                                    <FormNumberField
                                        className={'fieldFullWidth'}
                                        key={modalEditField?.fieldName}
                                        name={modalEditField?.fieldName}
                                        value={''}
                                        onBlurUpdate={handleBlurUpdate} 
                                        label={modalEditField?.label}
                                        min={modalEditField?.fieldName === 'En' ?  0  : ''}  // En = Enable
                                        max={modalEditField?.fieldName === 'En' ?  1 : ''}   // En = Enable  
                                    />
                                }
                            </Grid> 
                        }
                        {showChangeBy === '1' && searchForm &&
                            <Grid  item xs={12} sm={4} md={3}>
                                <AutoCompleteComponent 
                                    name={modalEditField?.fieldName}
                                    label="Search Text"
                                    options={autoCompleteOptions}
                                    loading={autoCompleteLoading}
                                    //setSearchValue={setSearchValue}
                                    handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                                    handleChangeAutoComplete={handleChangeAutoComplete}
                                    inputRef={inputRef}
                                    index={""}
                                    value={searchValue}
                                />
                            </Grid>
                        }
                    </Grid>
                }
    
            </DialogContent>
            <DialogActions>
                <Button 
                    variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleSubmitRowLocalStorage}
                >Submit</Button>
                <Button 
                    variant="contained"
                    size="medium"
                    color="error" 
                    onClick={onClose}
                >Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditMappingEventModal